<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
        <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
                <div v-html="publicacao.conteudo"></div>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Br from '@/config/barramento.js'

export default {
    data(){
        return{
            publicacao: "",
            mostrar: false
        }
    },

    methods:{
        fechar(){
            this.mostrar = false
        }
    },

    created(){
        Br.onLerPublicacao(publicacao => {
        
            this.publicacao = publicacao
            this.mostrar = true
        
        })
    }
}
</script>